module.exports = __webpack_public_path__ + "static/media/slots-languages.23e10374.png";